module.exports = __webpack_public_path__ + "img/ticket-02.ec9b08c7.svg";